<style lang="stylus">
.v-icon.trophy {
  font-size: 3rem !important;
  position absolute;
  padding: 24px 0px 0px 16px;
}
</style>

<template>
  <v-row>
    <div class="yellowBox">
      <v-icon dark class="trophy">mdi-trophy</v-icon>

      <p class="boldLetters">
        <strong>Congratulations, you can add your completed course to your transcript!</strong>
      </p>
      <div class="para">
        <p>Click the Add to Transcript button next to your completed course.</p>
      </div>
    </div>
  </v-row>
</template>
<script>
import { defineComponent } from 'vue';

export default defineComponent({});
</script>
